<template>
  <el-dialog :title="$t('communityRecommend.linkService')" :visible.sync="dialogVisible" width="70%"
    @close="handleClose">
    <el-form :model="addServRecommendInfo" ref="addForm" label-width="120px" :rules="rules">
      <el-form-item :label="$t('communityRecommend.selectService')">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-select v-model="addServRecommendInfo.shopId" style="width:100%" @change="queryAShopServs"
              :placeholder="$t('communityRecommend.selectShop')">
              <el-option v-for="item in addServRecommendInfo.shops" :key="item.shopId" :label="item.shopName"
                :value="item.shopId">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="10">
            <el-select v-model="addServRecommendInfo.servId" style="width:100%" @change="selectServs"
              :placeholder="$t('communityRecommend.selectService')">
              <el-option v-for="item in addServRecommendInfo.servs" :key="item.servId" :label="item.servName"
                :value="item.servId">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item :label="$t('communityRecommend.logo')" prop="logo">
        <upload-image-url ref="uploadImage" :callBackListener="'addServRecommend'"
          :callBackFunction="'notifyUploadCoverImage'" :imageCount="1">
        </upload-image-url>
      </el-form-item>
      <el-form-item :label="$t('communityRecommend.serviceName')" prop="prodName">
        <el-input v-model="addServRecommendInfo.prodName" :placeholder="$t('communityRecommend.requiredServiceName')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('communityRecommend.price')" prop="price">
        <el-input v-model="addServRecommendInfo.price" :placeholder="$t('communityRecommend.requiredPrice')">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveServRecommend">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveCommunityRecommend, queryShopsByAdmin, queryAdminServ } from '@/api/phone/communityRecommend/communityRecommendApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'

export default {
  name: 'AddServRecommend',
  components: {
    UploadImageUrl
  },
  data() {
    return {
      dialogVisible: false,
      addServRecommendInfo: {
        communityId: '',
        communityName: '',
        shopName: '',
        shopId: '',
        servId: '',
        recommendType: 'SERV',
        logo: '',
        prodName: '',
        price: '',
        url: '',
        shops: [],
        servs: []
      },
      rules: {
        logo: [
          { required: true, message: this.$t('communityRecommend.logoRequired'), trigger: 'blur' }
        ],
        prodName: [
          { required: true, message: this.$t('communityRecommend.serviceNameRequired'), trigger: 'blur' }
        ],
        price: [
          { required: true, message: this.$t('communityRecommend.priceRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.addServRecommendInfo.communityId = params.communityId
      this.addServRecommendInfo.communityName = params.communityName
      this._listAServRecommendShops()
      this.$nextTick(() => {
        this.$refs.uploadImage.clearImage()
      })
    },
    handleClose() {
      this.$refs.addForm.resetFields()
      this.clearAddServRecommendInfo()
    },
    async saveServRecommend() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          this.addServRecommendInfo.url = `/pages/homemaking/detail?servId=${this.addServRecommendInfo.servId}&shopId=${this.addServRecommendInfo.shopId}`
          try {
            await saveCommunityRecommend(this.addServRecommendInfo)
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error('保存失败:', error)
          }
        }
      })
    },
    clearAddServRecommendInfo() {
      this.addServRecommendInfo = {
        communityId: '',
        communityName: '',
        shopName: '',
        shopId: '',
        servId: '',
        recommendType: 'SERV',
        logo: '',
        prodName: '',
        price: '',
        url: '',
        shops: [],
        servs: []
      }
    },
    async _listAServRecommendShops() {
      try {
        const res = await queryShopsByAdmin({ page: 1, row: 100 })
        this.addServRecommendInfo.shops = res.data
      } catch (error) {
        console.error('获取店铺列表失败:', error)
      }
    },
    async queryAShopServs() {
      const shop = this.addServRecommendInfo.shops.find(item => item.shopId === this.addServRecommendInfo.shopId)
      if (shop) {
        this.addServRecommendInfo.shopName = shop.shopName
      }
      await this._listAShopServ()
    },
    async _listAShopServ() {
      try {
        const res = await queryAdminServ({
          page: 1,
          row: 500,
          shopId: this.addServRecommendInfo.shopId
        })
        this.addServRecommendInfo.servs = res.data
      } catch (error) {
        console.error('获取服务列表失败:', error)
      }
    },
    selectServs() {
      const serv = this.addServRecommendInfo.servs.find(item => item.servId === this.addServRecommendInfo.servId)
      if (serv) {
        this.addServRecommendInfo.prodName = serv.servName
        this.addServRecommendInfo.price = serv.defaultFee
        this.addServRecommendInfo.logo = serv.coverPhoto
        this.$refs.uploadImage.notifyPhotos([serv.coverPhoto])
      }
    }
  }
}
</script>

<style scoped>
.el-input {
  width: 100%;
}
</style>